import type {
  ClipboardEventHandler,
  CompositionEventHandler,
  ReactElement,
  RefObject,
} from 'react';
import { createContext, type KeyboardEvent } from 'react';
import type { Editor } from 'slate';
import type { RenderElementProps, RenderLeafProps } from 'slate-react';

export interface EditableProps {
  editableRef: RefObject<HTMLDivElement>;
  renderLeaf: (props: RenderLeafProps) => ReactElement;
  renderElement: (props: RenderElementProps) => ReactElement;
  onKeyDown: (event: KeyboardEvent<HTMLDivElement>) => void;
  onPaste: ClipboardEventHandler<HTMLDivElement>;
  onCompositionStart: CompositionEventHandler<HTMLDivElement>;
  onCompositionEnd: CompositionEventHandler<HTMLDivElement>;
}

export interface EditorContextValue {
  editor: Editor;
  focus: () => void;
  clear: () => void;
  editableProps: EditableProps;
}

export const editorContext = createContext<EditorContextValue>({} as never);

export function useEditorContext() {
  return useContext(editorContext);
}
